export default function menuToggle() {
  return {
    scope: {
      section: '='
    },
    template: `
      <md-button class="md-button-toggle" 
          ng-class="{'toggled' : isOpen(), 'disabled':section.disabled}"
          ng-click="toggle()"
          aria-controls="docs-menu-{{section.name | nospace}}"
          flex layout="row"
          aria-expanded="{{isOpen()}}">
              {{section.name}}
        <md-icon md-font-set="fa fa-chevron-down" class="md-toggle-icon" ng-class="{'toggled' : isOpen()}"></md-icon>
      </md-button>
      <md-tooltip ng-show="{{section.disabled}}" md-direction="right">
       {{section.disabled_message}}
      </md-tooltip>
      <ul ng-show="isOpen()" id="docs-menu-{{section.name | nospace}}" class="menu-toggle-list">
        <li ng-repeat="page in section.pages">
          <menu-link section="page"></menu-link>
          <md-tooltip ng-show="{{section.pastdue}}" md-direction="right">
           {{section.pastdue_message}}
          </md-tooltip>
        </li>
      </ul>`,
    link: function (scope, element) {
      const controller = element.parent().controller();

      scope.isOpen = function () {
        return controller.isOpen(scope.section);
      };
      scope.toggle = function () {
        controller.toggleOpen(scope.section);
      };

      var parentNode = element[0].parentNode.parentNode.parentNode;
      if (parentNode.classList.contains('parent-list-item')) {
        var heading = parentNode.querySelector('h2');
        element[0].firstChild.setAttribute('aria-describedby', heading.id);
      }
    }
  };
}
